import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { Props as BaseLinkProps } from "shared/components/common/base-link";

import type { headlineSection$key } from "scmp-app/queries/__generated__/headlineSection.graphql";

import { Container, HeadlineText, StyledBaseLink, StyledLinkIcon } from "./styles";

type Props = Omit<BaseLinkProps, "className" | "pathname"> & {
  className?: string;
  color: string;
  reference: headlineSection$key;
};

export const Headline: FunctionComponent<Props> = ({ className, color, reference, ...props }) => {
  const section = useFragment(
    graphql`
      fragment headlineSection on Section {
        name
        urlAlias
      }
    `,
    reference,
  );

  return (
    <Container>
      <StyledBaseLink className={className} pathname={section.urlAlias} {...props}>
        <HeadlineText $color={color}>{section.name}</HeadlineText>
        <StyledLinkIcon />
      </StyledBaseLink>
    </Container>
  );
};

Headline.displayName = "Headline";
